module.exports = __webpack_public_path__ + "img/Frame 1321315106@2x.010bdd0b.png";